import React, { useState, useCallback, useRef, useEffect } from 'react';
import { debounce } from 'lodash';
import { Input } from '../../../components/ui/input';
//import { useTranslation } from 'react-i18next';

interface DebouncedInputProps {
    placeholder?: string;
    type?: string;
    className?: string;
    initialValue?: string;
    debounceMs?: number;
    onDebouncedChange: (value: string) => void;
    isShowInputLength?: boolean;
}

export const DebouncedInput: React.FC<DebouncedInputProps> = ({
    placeholder,
    type = 'text',
    className,
    initialValue = '',
    debounceMs = 500,
    onDebouncedChange,
    isShowInputLength = true,
}) => {
    ////const { t } = useTranslation();
    const [internalValue, setInternalValue] = useState(initialValue);
    const [error, setError] = useState(false);
    const maxLength = 50;

    const debouncedCallback = useRef(
        debounce((value: string) => {
            onDebouncedChange(value);
        }, debounceMs)
    ).current;

    const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation();
        const value = e.target.value;
        setInternalValue(value);
        setError(value.length > maxLength);
        if (value.length <= maxLength) {
            debouncedCallback(value);
        }
    }, [debouncedCallback]);

    useEffect(() => {
        return () => {
            debouncedCallback.cancel();
        };
    }, [debouncedCallback]);

    useEffect(() => {
        setInternalValue(initialValue);
        setError(initialValue.length > maxLength);
    }, [initialValue]);

    return (
        <div className="w-full space-y-2">
            <Input
                onClick={(e) => e.stopPropagation()}
                type={type}
                placeholder={placeholder}
                value={internalValue}
                onChange={handleChange}
                maxLength={maxLength}
                className={`${className} ${error ? 'border-destructive' : ''}`}
            />
            {isShowInputLength && <div className="flex justify-end">
                <span className={`text-xs ${error ? 'text-destructive' : 'text-muted-foreground'}`}>
                    {internalValue.length}/{maxLength}
                </span>
            </div>
            }
            {/* {error && (
                <p className="text-xs text-destructive">
                    Title must not exceed 50 characters
                </p>
            )} */}
        </div>
    );
};